import { useCallback } from "react";

const useAnimationFrame = () => {
  const scrollTop = useCallback(() => {
    requestAnimationFrame(() =>
      window.scrollTo({
        top: 0,
        left: 0,
      })
    );
  }, []);

  return { scrollTop };
};

export default useAnimationFrame;
